import { render, staticRenderFns } from "./CreateAdmin.vue?vue&type=template&id=0970f584&scoped=true"
import script from "./CreateAdmin.vue?vue&type=script&lang=js"
export * from "./CreateAdmin.vue?vue&type=script&lang=js"
import style0 from "./CreateAdmin.vue?vue&type=style&index=0&id=0970f584&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0970f584",
  null
  
)

export default component.exports